import React, {Component} from 'react';

/**
 * Weight Adjustment Switcher component
 */
class WeightAdjustmentSwitcher extends Component {

  render() {
    const {selected, onSelect, selectedCriticalCare, casuistic, selectedBCS, openModalWithContent, data} = this.props;
    const shouldUncheckDisable = (selectedBCS < 5 || selectedCriticalCare || casuistic == "pregnancy" || casuistic == "lactation" || casuistic == "growth");

    if (selected && shouldUncheckDisable) {
      onSelect(null);
    }

    return (
      <div className="nppe2-fc-weight-adjustment-switcher nppe2-fc-check-box">
        <label>
          <input
            name="nppe2-fc-weight-adjustment"
            type="checkbox"
            checked={shouldUncheckDisable ? false : selected}
            onChange={(e) => onSelect(e.target.checked)}
            disabled = {shouldUncheckDisable ? "disabled" : ""}
          />
          <div className="nppe2-fc-check-box__label">
            <h2>{data.label}</h2>
          </div>
        </label>
        <a href="#" aria-label={data.aria}>
          <div className="nppe2-fc-info-button"
            onClick={ (e) => {
              openModalWithContent("BodyConditionWeightAdjustmentProgram");
              e.preventDefault();
            }}></div>
        </a>
      </div>
    );
  }
}

export default WeightAdjustmentSwitcher;
